jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupStickyMenu();
	setupColumns();
	setupSearch();
	setupBanner();
	setupAccessabilityToggles();
	setupScrollDetect();
	setupSelectURLChange();
	setupBackToTop();
	
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-menu-button").on('click', function(){
		jQuery('html').toggleClass('mobile-menu-open');
		jQuery('.text', this).text(jQuery('.text', this).text() == 'Menu' ? 'Close' : 'Menu');
	});
	
}

function setupStickyMenu(){ 
	
	jQuery("#sticky-menu-button").on('click', function(){
		jQuery('html').toggleClass('sticky-menu-open');
		jQuery('.text', this).text(jQuery('.text', this).text() == 'Menu' ? 'Close' : 'Menu');
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname){
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;

function setupSearch() {
	
	jQuery('#full-page').on('click', '.search-toggle.not-active', function(e){
				
		e.preventDefault();
		
		jQuery('html').addClass('search-open');
		jQuery('.search-toggle').removeClass('not-active');
		jQuery('input[name="s"]').focus();
		
		return false;
		
	});
	
	jQuery('#search-container, #mobile-search-container').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html').on('click', function(e){
		jQuery('html').removeClass('search-open');
		jQuery('.search-toggle').addClass('not-active');
	});
	
}


function setupBanner(){
	
	var banner = document.getElementById('global-alert');
	var closeButton = document.getElementById('close-alert');
	var html = document.getElementsByTagName('html')[0];
	
	if(!banner || !closeButton || !html)
		return false;
	
	//show banner if it hasn't been closed
	var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
	
	if(bannerHasBeenClosed)
		html.classList.remove('enable-global-alert');
	else
		banner.classList.add('show');
		html.classList.add('enable-global-alert');
	
	closeButton.addEventListener('click', function(){
		banner.classList.remove('show');
		html.classList.remove('enable-global-alert');
		sessionStorage.setItem('bannerHasBeenClosed', true);
	});
	
}

function setupAccessabilityToggles(){
	const contrastToggle = document.getElementById( 'contrast-toggle');
	const fontToggle = document.getElementById( 'font-toggle');
	const html = document.getElementsByTagName('html')[0];
	let darkMode = localStorage.getItem("dark-mode");
	let largeText = localStorage.getItem("large-text");
	
	const enableDarkMode = () => {
	  html.classList.add("dark-mode");
	  contrastToggle.classList.remove("active");
	  localStorage.setItem("dark-mode", "enabled");
	};
	
	const disableDarkMode = () => {
	  html.classList.remove("dark-mode");
	  contrastToggle.classList.add("active");
	  localStorage.setItem("dark-mode", "disabled");
	};
	
	if (darkMode === "enabled") {
	  enableDarkMode(); // set state of darkMode on page load
	}
	
	contrastToggle.addEventListener("click", (e) => {
		event.preventDefault();
	    darkMode = localStorage.getItem("dark-mode"); // update darkMode when clicked
	    if (darkMode === "disabled") {
			enableDarkMode();
	  	} else {
		  disableDarkMode();
		}
	});
	
	
	const enableLargeText = () => {
		  html.classList.add("large-text");
		  fontToggle.classList.remove("active");
		  localStorage.setItem("large-text", "enabled");
		};
		
		const disableLargeText = () => {
		  html.classList.remove("large-text");
		  fontToggle.classList.add("active");
		  localStorage.setItem("large-text", "disabled");
		};
		
		if (largeText === "enabled") {
		  enableLargeText(); // set state of largeText on page load
		}
		
		fontToggle.addEventListener("click", (e) => {
		  largeText = localStorage.getItem("large-text"); // update largeText when clicked
		  event.preventDefault();
		  if (largeText === "disabled") {
			enableLargeText();
		  } else {
			disableLargeText();
		  }
	});
	
	
	
}

function setupScrollDetect(){
	
	jQuery(window).on('scroll', function(){
		
		var offset = jQuery(window).scrollTop();
		var html = jQuery('html');
		
		if(offset > 220) {
			html.addClass('not-top');
		} else {
			html.removeClass('not-top');
		}
		
	});
	
}

function setupSelectURLChange() {
	
	jQuery('.url-change').on('change', function(){
		
		//console.log(jQuery(this).val());
		window.location = jQuery(this).val();
		
	});
	
}

function setupBackToTop(){
	
	jQuery(window).on('scroll', function(){
		
		var offset = jQuery(window).scrollTop();
		var html = jQuery('html');
		
		if(offset > 100) {
			html.addClass('not-top');
		} else {
			html.removeClass('not-top');
		}
		
	});
	
	jQuery('#top').on('click', function(){
		jQuery('html, body').animate({scrollTop: 0}, 'slow');
	});
	
}
